









































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Prop, Vue } from "vue-property-decorator";
import { pageDataType } from "../types";
import { HOST } from "../global";
import {
  TweenMax,
  TimelineLite,
  Power3,
  Power4,
  Power1,
  Power2,
  TimelineMax,
} from "gsap";
import ScrollMagic from "scrollmagic";
import gsap from "scrollmagic";

@Component({
  name: "MilestonesCard",
})
export default class MilestonesCard extends Vue {
  @Prop() readonly compData!: any;
  public HOST: string = HOST;
  public imgTextAnim() {
    const mltimeline = new TimelineMax()
      .staggerFrom(
        ".sq-milestone-list ul li",
        0.6,
        {
          yPercent: 40,
          autoAlpha: 0,
          ease: Power4.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.1"
      )
      .from(
        ".sq-milestone-image",
        0.6,
        {
          yPercent: 40,
          scale: 0.9,
          autoAlpha: 0,
          ease: Power2.easeInOut,
          clearProps: "all",
        },
        "-=.1"
      );
    const controller = new ScrollMagic.Controller();
    const scene = new ScrollMagic.Scene({
      triggerElement: ".sq-milestones",
      reverse: false,
    })
      .setTween(mltimeline)
      .addTo(controller);

    //  animation3
  }
  public mounted() {
     if (window.matchMedia("(min-width: 1025px)").matches) {
        this.imgTextAnim();
       }
    
  }
}
